import React from 'react';
import { BannerAdsCarouselProps } from '~types/index'
import { GPTContainer, GPTSlot } from './GPT';
import Carousel from '../Carousel';

const FREEZING_TIME_TO_CAROUSEL = 15;

const BannerAdsCarousel = ({
  id,
  path,
  size,
  carrouselLength,
  autoplaySpeed,
  skeleton,
  targeting,
  aspectRatio,
  freezingTimeToLoad = 0,
}: BannerAdsCarouselProps) => {
  return (
    <Carousel
      length={carrouselLength}
      autoplaySpeed={autoplaySpeed}
      freezingTime={FREEZING_TIME_TO_CAROUSEL}
    >
      <GPTContainer fallback={skeleton} freezingTime={freezingTimeToLoad}>
        {Array.from({ length: carrouselLength }).map((x, i) => (
          <GPTSlot
            id={`${id}-${i + 1}`}
            key={`${id}-${i + 1}`}
            selector={id}
            adUnitPath={path}
            slotSize={size}
            fallback={skeleton}
            aspectRatio={aspectRatio}
            targeting={{
              ...targeting,
              pos: ['carousel', i + 1],
              adtype: ['native'],
            }}
          />
        ))}
      </GPTContainer>
    </Carousel>
  );
};

export default BannerAdsCarousel;
